export default __webpack_public_path__ + "static/media/Video.b7411dc7.svg";